import moment from "moment-jalaali";
moment.loadPersian({ dialect: "persian-modern" });

/**
 * 
 * @param {string} gregorianDate 
 * @returns {string}
 */
export function gregorianToJalali(gregorianDate) {
  return moment(gregorianDate, "YYYY-MM-DD").format("jYYYY/jMM/jDD");
}

export function timeAgo(dateString) {
    const now = new Date();
    const date = new Date(dateString);
    const diffInSeconds = Math.floor((now - date) / 1000);
  
    if (diffInSeconds < 5) return "هم اکنون";
    if (diffInSeconds < 60) return `${diffInSeconds} ثانیه پیش`;
  
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes} دقیقه پیش`;
  
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours} ساعت پیش`;
  
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays === 1) return "دیروز";
    if (diffInDays < 7) return `${diffInDays} روز پیش`;
  
    const diffInWeeks = Math.floor(diffInDays / 7);
    if (diffInWeeks < 4) return `${diffInWeeks} هفته پیش`;
  
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) return `${diffInMonths} ماه پیش`;
  
    const diffInYears = Math.floor(diffInDays / 365);
    return `${diffInYears} سال پیش`;
  }
  

 export const formatNumberForDisplay = (raw = "") => {
    if (raw === "" || raw == null) return "";
    const parts = String(raw).split(".");
    const intPart = parts[0].replace(/\D+/g, "") || "0";
    const fracPart = parts[1] ?? null;
    const withSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const formatted = fracPart != null ? `${withSep}.${fracPart.replace(/\D+/g, "")}` : withSep;
    return `${formatted}`;
  };

